export default "__VITE_ASSET__DETY2z1y__"